export const OWN_FARMING_MENU_ITEM_KEY = "transition-CB-to-CF";
